import { render, staticRenderFns } from "./PoliticaDePrivacidade.vue?vue&type=template&id=202ccd9b&scoped=true"
import script from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js"
import style0 from "./PoliticaDePrivacidade.vue?vue&type=style&index=0&id=202ccd9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ccd9b",
  null
  
)

export default component.exports